import React from 'react';
import { LoansQueryProvider } from './list/LoansQueryProvider';

export const LoansProviders = ({ children }: any) => {
	return <LoansQueryProvider>{children}</LoansQueryProvider>;
};
